import React from 'react'

import { selectBusinessEvents } from '../../../store/businessEvent/businessEvent'
import { useAppSelector } from '../../../store/hooks'

import './BusinessEventsDisabledBanner.scss'

export const BusinessEventsDisabledBanner = () => {
  const businessEvents = useAppSelector(selectBusinessEvents)

  return (
    <div className='d-flex gap-2 rounded-2 zocks-bg-color-gray-100 border zocks-border-color-gray-300 zocks-p-1.25'>
      <div className='business-events-disabled-banner-icon-wrapper d-flex align-items-center justify-content-center'>
        <i className='bi bi-power zocks-text-gray-700' />
      </div>
      <div className='d-flex flex-column gap-2'>
        <div className='d-flex flex-column gap-1'>
          <span className='paragraph-medium bold zocks-text-gray-900'>Client Signal detection is disabled in your Account</span>
          {businessEvents.length ? (
            <span className='paragraph-small zocks-text-gray-700'>You're not detecting new signals. Previously detected signals are shown below.</span>
          ) : null}
        </div>
        <a
          className='paragraph-small zocks-text-primary text-decoration-underline'
          href='/dashboard/workspace/setup/settings'
          target='_blank'
          rel='noopener noreferrer'
        >
          Go to Settings to enable detection
        </a>
      </div>
    </div>
  )
}
